<template>
  <div
    class="
      tw-flex
      tw-items-center
      tw-gap-4
      tw-px-4
      tw-py-9
      tw-bg-sf-ai-subtle
      tw-text-sf-ai-darker
      tw-rounded-lg
      tw-mb-6
    "
  >
    <div
      class="
        sf-spinner sf-spinner-primary sf-spinner-l
        tw-border-sf-ai tw-h-[30px] tw-w-[30px]
        tw-flex-[0_0_30px]
      "
    ></div>
    <div>
      {{ loadingLabel }}
    </div>
  </div>
  <div v-for="id in allDocumentIds" :key="id" class="tw-mb-2">
    <DocumentCard :document="documents[id]" :ui-state="UIState.Loading" />
  </div>
</template>

<script setup lang="ts">
import { UIState } from '../types'

import { storeToRefs } from 'pinia'

import DocumentCard from './document-card.vue'
import useI18n from '@app/shared/vue/composables/use-I18n'

import { useOCRDocuments } from '../store/use-ocr-documents'

const I18n = useI18n()

const documentStore = useOCRDocuments()

const { allDocumentIds, documents } = storeToRefs(documentStore)

const loadingLabel = I18n.t('ai_ocr_requests.steps.messages.loading')
</script>
